import React from 'react';

function formatCurrency(v: number) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(v || 0);
}

function formatPct(v: number) {
  return `${(v || 0).toFixed(1)}%`;
}

export default function KpiCard({
  title,
  value,
  format,
  subtitle,
}: {
  title: string;
  value: number;
  format: 'currency' | 'number' | 'percentage' | 'days';
  subtitle?: string;
}) {
  const text =
    format === 'currency'
      ? formatCurrency(value)
      : format === 'percentage'
        ? formatPct(value)
        : format === 'days'
          ? `${Math.round(value || 0)}`
          : new Intl.NumberFormat('en-US').format(value || 0);

  return (
    <div className="card">
      <h3>{title}</h3>
      <div className="metric">{text}</div>
      {subtitle ? <div className="sub">{subtitle}</div> : null}
    </div>
  );
}

